import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { Box, ButtonBase, IconButton, InputBase } from '@material-ui/core';
import moment from 'moment';
import { DropDownIcon, DropUpIcon } from '../../Icon';

const useStyles = makeStyles((theme) => ({
  popver: {
    '& .MuiPaper-root': {
      backgroundColor: 'transparent',
      boxShadow: 'unset',
      borderRadius: '0 !important',
      border: '0',
      padding: '0',
      margin: '0',
    },
  },
  root: {
    position: 'relative',
    width: '18rem',
    // height: '13.063rem',
    borderRadius: '0.168rem',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    marginLeft: '0.9rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      transform: 'translate(-105%, 5.5rem)',
      borderRight: '0.9rem solid rgba(0, 0, 0, 0.1)',
      borderBottom: '1.2rem solid transparent',
      borderTop: '1.2rem solid transparent',
    },
  },
  selectTime: {
    height: '2.5rem',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1.25rem',
  },
  arrowIcon: {
    height: '0.688rem',
    width: '0.688rem',
    color: '#538fff',
  },
  inputBase: {
    width: '4.188rem',
    height: '3.75rem',
    borderRadius: '0.5rem',
    boxShadow: '-1px 4px 10px 0 rgba(221, 232, 251, 0.58)',
    border: 'solid 1px #e4e7eb',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.125rem',
    fontWeight: '500',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontSize: '1.125rem',
      fontWeight: '500',
      color: '#2e4469',
    },
  },
  typography: {
    fontSize: '1.125rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  button: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    color: '#538fff',
    marginRight: '1.063rem',
    padding: '0.5rem',
  },
  triangleIcon: {
    position: 'absolute',
    top: '0',
    left: '0',
    transform: 'translate(-95%, 5.5rem)',
    borderRight: '0.9rem solid #fff',
    borderBottom: '1.2rem solid transparent',
    borderTop: '1.2rem solid transparent',
  },
  iconButton: {
    '&.Mui-disabled .MuiSvgIcon-root': {
      color: 'rgb(39 22 22 / 26%)',
    },
  },
}));

export default function TimeSelectPop({ value, onChange, closePop, anchorEl, disableFuture, date }) {
  const classes = useStyles();

  const [currDate, setCurrDate] = useState(value instanceof Object ? value.clone() : moment());

  const formatDATE = useMemo(() => {
    let result = {};
    result.h = currDate.format('hh');
    result.m = currDate.format('mm');
    result.a = currDate.format('A');
    return result;
  }, [currDate]);

  const hourHandle = (number) => {
    return () => {
      setCurrDate(currDate.clone().add(number, 'h'));
    };
  };

  const minuteHandle = (number) => {
    return () => {
      setCurrDate(currDate.clone().add(number, 'm'));
    };
  };

  const okHandle = () => {
    onChange(currDate);
    closePop();
  };
  useMemo(() => {
    setCurrDate(value?.isValid?.() ? value.clone() : moment());
  }, [anchorEl]);

  const topArrowDisable = (flag) => {
    if (!disableFuture || !date) return false;
    let temp;
    let date2 = date.clone();
    date2.set('hour', currDate.get('hour'));
    date2.set('minute', currDate.get('minute'));
    switch (flag) {
      case 'h':
        if (currDate.get('hours') === 11 || currDate.get('hours') === 23) return true;
        temp = date2.add(1, 'hours');
        break;
      case 'm':
        if (currDate.get('minute') === 59) return true;
        temp = date2.add(1, 'minute');
        break;
      case 'a':
        if (date2.get('hour') >= 12) return true;
        temp = date2.add(12, 'hours');
        break;
      default:
        return false;
    }
    return !temp.isSameOrBefore(moment(), 'minute');
  };

  const bottonArrowDisable = (flag) => {
    if (!disableFuture || !date) return false;
    if (!date.isSameOrBefore(moment(), 'day')) return true;
    switch (flag) {
      case 'h':
        return currDate.get('hours') === 0 || currDate.get('hours') === 12;
      case 'm':
        return currDate.get('minute') <= 1;
      case 'a':
        return currDate.get('hours') < 12;
      default:
        return false;
    }
  };

  return (
    <div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closePop}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        className={classes.popver}
      >
        <div className={classes.root}>
          <Typography className={classes.selectTime}>Select time</Typography>
          <Box display="flex" justifyContent="space-around" alignItems="center">
            <Box display="flex" flexDirection="column">
              <IconButton className={classes.iconButton} onClick={hourHandle(1)} disabled={topArrowDisable('h')}>
                <DropUpIcon className={classes.arrowIcon} />
              </IconButton>
              <InputBase className={classes.inputBase} disabled value={formatDATE.h} />
              <IconButton className={classes.iconButton} onClick={hourHandle(-1)} disabled={bottonArrowDisable('h')}>
                <DropDownIcon className={classes.arrowIcon} />
              </IconButton>
            </Box>
            <Typography className={classes.typography}>:</Typography>
            <Box display="flex" flexDirection="column">
              <IconButton className={classes.iconButton} onClick={minuteHandle(1)} disabled={topArrowDisable('m')}>
                <DropUpIcon className={classes.arrowIcon} />
              </IconButton>
              <InputBase className={classes.inputBase} disabled value={formatDATE.m} />
              <IconButton className={classes.iconButton} onClick={minuteHandle(-1)} disabled={bottonArrowDisable('m')}>
                <DropDownIcon className={classes.arrowIcon} />
              </IconButton>
            </Box>
            <Typography className={classes.typography}>:</Typography>
            <Box display="flex" flexDirection="column">
              <IconButton className={classes.iconButton} onClick={hourHandle(12)} disabled={topArrowDisable('a')}>
                <DropUpIcon className={classes.arrowIcon} />
              </IconButton>
              <InputBase className={classes.inputBase} disabled value={formatDATE.a} />
              <IconButton className={classes.iconButton} onClick={hourHandle(-12)} disabled={bottonArrowDisable('a')}>
                <DropDownIcon className={classes.arrowIcon} />
              </IconButton>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <ButtonBase className={classes.button} onClick={closePop}>
              CANCEL
            </ButtonBase>
            <ButtonBase className={classes.button} onClick={okHandle}>
              OK
            </ButtonBase>
          </Box>
          <div className={classes.triangleIcon} />
        </div>
      </Popover>
    </div>
  );
}
